import config from "../../utils/config";


//sabee functions todo: copy to new file

export async function getInventory() {
  const tester = 'test';
  const res = await fetch(config.sabee.getRooms, { // POST to our backend server with the token and charge details
    method: 'PATCH',
    body: JSON.stringify({
        test: tester
      }
    ),

  });

  const data = await res.json();
 // let raw = await JSON.parse(data.body)

  //console.log(await data)

  return await data
}



export async function createCustomer(email, fullName, auth0_user_id, access_token) {
  const res = await fetch(config.stripe.createCustomerUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
      email: email,
      name: fullName,
    }),

  });

  const data = await res.json();
//console.log(res)
  //console.log('onToken');

  //console.log(await data);
  const cusObj = JSON.parse(await data.body);
  //console.log(await cusObj)
  const response = await fetch(config.stripe.addCustomerToUserUrl, { // POST to our backend server with the token and charge details
    method: 'PATCH',
    body: JSON.stringify({
      user_id: auth0_user_id,
      stripe_customer_id: cusObj.customer.id,
      accessToken: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ik56VTJSRFUwUlRreE56a3pSVEJGUVRSQk5rSkNOVE14UmpkRk9EWXdSVGRHUkRCRE9EQTBPUSJ9.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.GTksNoN6ichbb27C5cUhBROphzBElxHbV8cKSVtWz5KiqsmCa7TRMcElLP1MRtS679ff6XIuHOYa_oFalzVHlbnECB4-kDCZGgEpSBhyb5daCrSBdGw3UQeLlP2M3kGOgCwm909iSrMDJAUmBPG_7fotJ_5ihUlNS3iR5oRAgZD9CuJHvOzB3x8HUBo1r0Vz4egWVbW_smQ_TXHBDoCXqzXv24a2owh1Lx7aH_x76d97uZhjuIVL9msqac3z_RdHqdUl-JdCYJrY_xYvN0Co9dmj8-kQ2ok6Oj2dlYM-eJ4YfIq9A2u0KD91Qw05vRi311BqF7u-rLiK0z_mfrhyFw'


    }),

  });

  const d = await response.json();

  //console.log('onToken');

  //console.log(d);
 //console.log(response)

return cusObj.customer.id
}



export async function retrieveCustomer(cus_id) {
  const res = await fetch(config.stripe.retrieveCustomerUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
        stripe_customer_id:cus_id
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

export async function updateCustomer(cus_id, cus_data) {
  const res = await fetch(config.stripe.updateCustomerUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
        stripe_customer_id:cus_id,
        cusData:cus_data
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

export async function createPaymentIntent(amount, currency, cus_id, confirm, capture_method, metadata, description) {
  const amount_decimal = amount*100;
  const res = await fetch(config.stripe.createPaymentIntentUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
        amount: amount_decimal,
        currency: currency,
        stripe_customer_id:cus_id,
        confirm: confirm,
        capture_method:capture_method,
      metadata:metadata,
      description: description
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body).paymentIntent

  //console.log(await raw)

  return await raw
}


export async function retrievePaymentIntents(cus_id) {
  const res = await fetch(config.stripe.retrievePaymentIntentsUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
     stripe_customer_id: cus_id
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)
  //console.log(await data)
  //console.log(await raw)

  return await raw.paymentIntents
}


export async function refundPaymentIntent(paymentIntent) {
  const res = await fetch(config.stripe.refundPaymentIntentUrl, { // POST to our backend server with the token and charge details
    method: 'GET',
    body: JSON.stringify({
     paymentIntent: paymentIntent
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}


export async function updatePaymentIntent(paymentIntent, reservationID, email, name) {
  const res = await fetch(config.stripe.updatePaymentIntentUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
     paymentIntent: paymentIntent,
      reservationID: reservationID,
      name: name,
      email: email
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}


// for bank transfer and maybe pay later?
export async function createCharge(amount, currency, description) {
  const res = await fetch(config.stripe.createChargeUrl, { // POST to our backend server with the token and charge details
    method: 'GET',
    body: JSON.stringify({
        amount: amount,
        currency: currency,
        description: description

      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

// for bank transfer and maybe pay later?
export async function createPaidCharge(amount, currency, description, source) {
  const res = await fetch(config.stripe.createChargeUrl, { // POST to our backend server with the token and charge details
    method: 'GET',
    body: JSON.stringify({
        amount: amount,
        currency: currency,
      source:source,
        description: description

      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

export async function updateCharge(chargeID, reservationID) {
  const res = await fetch(config.stripe.updateChargeUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
        chargeID:chargeID,
      reservationID: reservationID

      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

export async function refundCharge(charge) {
  const res = await fetch(config.stripe.refundChargeUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
      charge:charge

      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

export async function retrieveCharges(cus_id) {
  const res = await fetch(config.stripe.retrieveChargesUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
      stripe_customer_id:cus_id

      }
    ),

  });

  const data = await res.json();
  //console.log(data)
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw.charges
}

export async function createSource(source) {
  const res = await fetch(config.stripe.createSourceUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
source:source
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}

export async function attachSource(sourceID, cus_id) {
  const res = await fetch(config.stripe.attachSourceUrl, { // POST to our backend server with the token and charge details
    method: 'POST',
    body: JSON.stringify({
sourceID:sourceID,
stripe_customer_id:cus_id
      }
    ),

  });

  const data = await res.json();
  let raw = await JSON.parse(data.body)

  //console.log(await raw)

  return await raw
}






